import React from 'react'

import { Maybe, NewsCollectionFieldsFragment } from '../../../generated/graphql'
import Layout from '../../shared/Layout'
import { IntroductionSection } from './IntroductionSection'
import { NewsSection } from './NewsSection'
import { SlideshowSection } from './SlideshowSection'
import { VisionSection } from './VisionSection'

interface StaticNewIndexProps {
  newsItems: Maybe<NewsCollectionFieldsFragment>[]
}

const NewIndexTemplate: React.FC<StaticNewIndexProps> = ({ newsItems }) => (
  <Layout>
    <SlideshowSection />
    <NewsSection newsItems={newsItems} />
    <VisionSection />
    <IntroductionSection />
  </Layout>
)

export default NewIndexTemplate
